const mod = (a: number, n: number) => ((a % n) + n) % n;

/**
 * Per-item CSS `order` so that item `newActiveIndex` ends up visually centered.
 * Center is computed as floor(n/2) inside the function.
 * Returns SIGNED orders in a symmetric window around 0.
 *
 * Example: n=5, newActiveIndex=4 -> [1, 2, -2, -1, 0]
 * (sorting by these orders gives visual sequence [-2,-1,0,1,2], so 4 is at center)
 */
export function calcFlexOrdersSigned(n: number, newActiveIndex: number): number[] {
  if (n <= 0) return [];
  const activeIndex = Math.floor(n / 2);
  const a = mod(newActiveIndex, n);
  const out = new Array<number>(n);
  for (let i = 0; i < n; i++) {
    // shift indices so that "a" maps to center (order 0), then map to signed window
    out[i] = mod(i - a + activeIndex, n) - activeIndex;
  }
  return out;
}

/**
 * Same as above, but shifted to NON-NEGATIVE orders (0..n-1).
 * Useful if you prefer to avoid negative CSS order values.
 *
 * Example: n=5, newActiveIndex=4 -> [3, 4, 0, 1, 2]
 */
export function calcFlexOrders(n: number, newActiveIndex: number): number[] {
  const signed = calcFlexOrdersSigned(n, newActiveIndex);
  const activeIndex = Math.floor(n / 2);
  return signed.map(v => v + activeIndex);
}